import InfoCarousel from "../infoCarousel/infoCarousel.vue";
import download from "../../../util/download";
import { INFO_GET_DATA } from "../../../util/mutationTypes";

window.showImage = (src, alt) => {
  let imgWrap = document.createElement("div");
  imgWrap.className = "image-modal";
  imgWrap.innerHTML = `<img src="${src}" alt="${alt}" class = "modal-img">`;
  imgWrap.onclick = function (e) {
    this.parentElement.removeChild(this);
  };
  document.getElementById("info-wrapper").appendChild(imgWrap);
};
export default {
  name: "Info",
  components: {
    InfoCarousel
  },
  data: function () {
    return {
      showEmailModal: false,
      email: "",
      isEmailValid: false,
      infoResult: {}
    };
  },
  props: {
    id: {
      default: 0
    },
    serviceId: {
      default: 0
    },
    noNewModal: Boolean
  },
  methods: {
    downloadPdf() {
      download.downloadInfoPdf(
        this.infoResult.id,
        this.infoResult.name,
        this.lang,
        this.serviceId
      );
    },
    async loadData() {
      await this.$store.dispatch(INFO_GET_DATA, {
        id: this.id,
        serviceId: this.serviceId,
        lang: this.lang
      });
      this.infoResult = this.$store.state.ItemInformationStorage.infoResult;
    },
    sendEmail() {
      download.infoToEmail(this.infoResult.id, this.email, this.lang);
      this.showEmailModal = false;
    },
    validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    print() {
      download.printInfoPdf(this.infoResult.id, this.lang);
    },
    showMap() {
      this.$emit("showMapFromInfo", {
        id: this.infoResult.id,
        openFromInfo: true
      });
    }
  },
  computed: {
    lang() {
      return this.$store.state.SettingStorage.language;
    },
    isCoordinate() {
      if (this.infoResult) {
        if (this.infoResult.type == "hotel") {
          let coords = this.$store.state.InitDataStorage.coordinate;
          if (coords.length) {
            for (let i = 0; i < coords.length; i++) {
              for (let j = 0; j < coords[i].hotels.length; j++) {
                if (coords[i].hotels[j].id == this.id) {
                  return true;
                }
              }
            }
          }
        }
      }
      return false;
    },
    isDescription() {
      return (
        this.infoResult &&
        this.infoResult.descriptions &&
        this.infoResult.descriptions.length > 0
      );
    },
    infoResultLeftColumn() {
      if (this.isDescription) {
        let count = Math.ceil(this.infoResult.descriptions.length / 2);
        return this.infoResult.descriptions.slice(0, count);
      } else {
        return 0;
      }
    },
    infoResultRightColumn() {
      if (this.isDescription) {
        let count = Math.ceil(this.infoResult.descriptions.length / 2);
        return this.infoResult.descriptions.slice(count);
      } else {
        return 0;
      }
    },
    isWebDataInfo() {
      return this.isDescription || this.infoResult?.photo?.length > 0;
    }
  },
  watch: {
    email: function (val) {
      this.isEmailValid = this.validateEmail(val);
    }
  },
  created() {
    this.loadData();
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
  },
  destroyed() {
    document.getElementsByTagName("body")[0].style.overflow = "auto";
  }
};
